import { Typography } from "antd";
import { DATE_TIME_FORMAT, INPUT_TYPE, REGEX } from "config/constants";
import { CAMPAIGN_TYPE } from "features/Campaign/constants";
import { useFlags } from "flagsmith/react";
import { useLazySalesChannel } from "hooks/salesChannel";
import { t } from "i18next";
import moment from "moment";
import { useEffect } from "react";
import { getQuery } from "utils/helperFuncs";

const useCampaignInfo = ({ form, isUpdate }) => {
  const GET_QUERY = getQuery();
  const isCashDiscountCreate =
    !isUpdate && (GET_QUERY.campaignType === CAMPAIGN_TYPE.CASH_DISCOUNT || GET_QUERY.campaignType === "CASH_DISCOUNT");

  const flags = useFlags(["is_disabled_saleschannel_web_van_hanh"]);
  const isDisabledSalesChannelWebVanHanh = flags.is_disabled_saleschannel_web_van_hanh.enabled;

  const { convertedData: dataSalesChannel, getSalesChannel, loading: loadingSalesChannel } = useLazySalesChannel();

  const disabledDate = (current) => {
    const now = moment().startOf("day");
    return current.isBefore(now, "day");
  };

  // const disabledTime = (current) => {
  //   const now = moment();
  //   const nowPlus30 = now.clone().add(30, "minutes");

  //   if (!current || !current.isSame(now, "day")) {
  //     return {};
  //   }

  //   return {
  //     disabledHours: () => [...Array(24).keys()].filter((h) => h < nowPlus30.hour()),
  //     disabledMinutes: (h) =>
  //       h === nowPlus30.hour() ? [...Array(60).keys()].filter((m) => m < nowPlus30.minute()) : [],
  //   };
  // };

  const customDataSalesChannel = () => {
    return dataSalesChannel?.map((item) => {
      return {
        ...item,
        disabled: !isCashDiscountCreate && isDisabledSalesChannelWebVanHanh && item.label === "WEB VẬN HÀNH",
      };
    });
  };

  const fetchSalesChannelIfNeeded = () => {
    if (!dataSalesChannel) {
      getSalesChannel();
    }
  };

  const handleSalesChannelDropdownOpen = (visible) => {
    if (visible) {
      fetchSalesChannelIfNeeded();
    }
  };

  useEffect(() => {
    if (isUpdate) {
      fetchSalesChannelIfNeeded();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const commonInfoFields = [
    {
      formItemOptions: {
        label: <Typography.Text strong>{t("campaign.form.campaignName")}</Typography.Text>,
        name: "promoName",
        rules: [
          {
            required: true,
            message: t("common.messageRequiredType", { message: t("campaign.form.campaignName") }),
          },
          {
            pattern: REGEX.TEXT_TRIM_SPACE,
            message: t("supplier.placeholderInput.whiteSpace"),
          },
        ],
      },
      inputOptions: {
        placeholder: t("campaign.form.campaignNamePlaceholder"),
        maxLength: 100,
      },
    },
    {
      type: INPUT_TYPE.RANGE_PICKER,
      showTime: {
        defaultValue: [moment("00:00:00", "HH:mm:ss"), moment("00:00:00", "HH:mm:ss")],
      },
      formItemOptions: {
        label: <Typography.Text strong>{t("campaign.form.campaignPeriod")}</Typography.Text>,
        name: "period",
        rules: [
          {
            required: true,
            message: t("common.messageRequiredSelect", {
              message: t("campaign.form.campaignPeriod"),
            }),
          },
        ],
      },
      inputOptions: {
        placeholder: [t("campaign.form.periodFromPlaceholder"), t("campaign.form.periodToPlaceholder")],
        separator: <>-</>,
        style: {
          width: "100%",
        },
        format: DATE_TIME_FORMAT,
        disabledDate: disabledDate,
        // disabledTime: disabledTime,
      },
    },
    {
      type: INPUT_TYPE.SELECT,
      formItemOptions: {
        label: <Typography.Text strong>{t("campaign.form.buyChannel")}</Typography.Text>,
        name: "buyChannels",
        rules: [
          {
            required: true,
            message: t("common.messageRequiredSelect", { message: t("campaign.form.buyChannel") }),
          },
        ],
      },
      inputOptions: {
        placeholder: t("campaign.form.buyChannelPlaceholder"),
        options: customDataSalesChannel(),
        mode: "multiple",
        filterOption: true,
        optionFilterProp: "label",
        onDropdownVisibleChange: handleSalesChannelDropdownOpen,
        allowClear: true,
        loading: loadingSalesChannel,
      },
    },
  ];

  const defaultBannerList = form?.getFieldsValue(["banner"])?.banner || [];

  return { commonInfoFields, defaultBannerList, form };
};
export default useCampaignInfo;
